var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_89",
    "data-name": "Groupe 89",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.668,
    height: 18.628,
    viewBox: "0 0 27.668 18.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_173",
    "data-name": "Trac\\xE9 173",
    d: "M2.157,2.5a.657.657,0,0,0-.657.657V4.47a.657.657,0,0,0,.657.657H3.47a.657.657,0,0,0,.657-.657V3.157A.657.657,0,0,0,3.47,2.5Zm1.313.657H2.157V4.47H3.47Z",
    transform: "translate(-1.5 -2.5)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_175",
    "data-name": "Trac\\xE9 175",
    d: "M2.157,2.5a.657.657,0,0,0-.657.657V4.47a.657.657,0,0,0,.657.657H3.47a.657.657,0,0,0,.657-.657V3.157A.657.657,0,0,0,3.47,2.5Zm1.313.657H2.157V4.47H3.47Z",
    transform: "translate(-1.5 5.501)",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_176",
    "data-name": "Trac\\xE9 176",
    d: "M2.157,2.5a.657.657,0,0,0-.657.657V4.47a.657.657,0,0,0,.657.657H3.47a.657.657,0,0,0,.657-.657V3.157A.657.657,0,0,0,3.47,2.5Zm1.313.657H2.157V4.47H3.47Z",
    transform: "translate(-1.5 13.501)",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_174",
    "data-name": "Trac\\xE9 174",
    d: "M5,4.034A1.089,1.089,0,0,1,6.136,3H26.583a1.089,1.089,0,0,1,1.136,1.034,1.089,1.089,0,0,1-1.136,1.034H6.136A1.089,1.089,0,0,1,5,4.034Zm1.136,7.237a1.038,1.038,0,1,0,0,2.068H26.583a1.038,1.038,0,1,0,0-2.068Zm0,8.271a1.038,1.038,0,1,0,0,2.068H26.583a1.038,1.038,0,1,0,0-2.068Z",
    transform: "translate(-0.051 -2.99)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.c54c84ebaef985f5e7317cd1409ad0bb.svg";
export { ForwardRef as ReactComponent };